export const EN = { code: 'en', language: 'English' }
export const TH = { code: 'th', language: 'ภาษาไทย' }

export const allLanguages = [EN, TH]
